import React from 'react';

interface Props {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

// Standard widget/chart container used on the Booking Dashboard and Reports pages.
export default function BookingDashboardCard({ title, action, children, className = '' }: Props) {
  return (
    <div className={`bg-white border border-strivre-lightnavy rounded-lg overflow-hidden ${className}`}>
      <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
        <h3 className="text-sm font-bold text-strivre-navy">{title}</h3>
        {action}
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
}
